import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from 'components/icon/icon.component';
import { AppIcon } from 'weavix-shared/models/icon.model';

@Component({
    selector: 'app-tab-header',
    templateUrl: './tab-header.component.html',
    styleUrl: './tab-header.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,

        IconComponent,
    ],
})
export class TabHeaderComponent {
    readonly headerTextKey = input.required<string>();
    readonly icon = input.required<AppIcon>();
    readonly descriptionTextKey = input<string>();
}
